import { render, staticRenderFns } from "./c-tab.vue?vue&type=template&id=4f6c2575"
import script from "./c-tab.vue?vue&type=script&lang=js"
export * from "./c-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports